import React, { useState } from 'react';
import { toast } from 'sonner';
import { formattaRoma, giornoDiRoma } from '../../utils/percorso';
import { API, axios } from '../../utils/api';
import Icona from '../cliente/Icone';
import Disponibilita from '../Disponibilita';

// Pezzi comuni a più schede della scheda cliente: il feed con l'iniziale di chi, le note interne, la griglia della
// disponibilità, l'errore del server in un toast.

export const errore = (e) => toast.error(typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'Non riuscito');

// «Oggi · 21:53», «Ieri · 09:10», «14 set · 17:30». Sempre l'ora di **Roma**: il server scrive le date in UTC
// senza dirlo, e leggendole con `new Date()` una nota delle 21:53 si leggeva «19:53».
export const quando = (iso) => {
  if (!iso) return '';
  const ora = formattaRoma(iso, { hour: '2-digit', minute: '2-digit' });
  if (!ora) return '';
  const giorno = giornoDiRoma(iso);
  const oggi = giornoDiRoma(new Date());
  const ieri = giornoDiRoma(new Date(Date.now() - 24 * 60 * 60 * 1000));
  if (giorno === oggi) return `Oggi · ${ora}`;
  if (giorno === ieri) return `Ieri · ${ora}`;
  return `${formattaRoma(iso, { day: 'numeric', month: 'short' })} · ${ora}`;
};

// Ultime novità e cronologia: pallino colorato, iniziale di chi (il cliente in grigio), testo, quando e chi
export const Feed = ({ voci, vuoto = 'Ancora niente.' }) => (
  <div className="feed">
    {!voci.length && <p className="vuoto">{vuoto}</p>}
    {voci.map((e) => (
      <div key={e.id}>
        <i className={`dot ${e.colore}`} />
        <div style={{ minWidth: 0 }}>
          <b><i className={`chi ${e.chi?.tipo === 'staff' ? `col-${e.chi.colore}` : e.chi?.tipo}`}>{e.chi?.iniziale}</i>{e.testo}</b>
          <span>{[quando(e.data), e.chi?.tipo === 'staff' ? e.chi.nome : e.chi?.tipo === 'cliente' ? 'il cliente' : null, e.nota ? `“${e.nota}”` : null].filter(Boolean).join(' · ')}</span>
        </div>
      </div>
    ))}
  </div>
);

export const NoteInterne = ({ clienteId, note, onFatto, aggiungi = '/note', aperta = false, limite = 4 }) => {
  const [scrivi, setScrivi] = useState(aperta);
  const [testo, setTesto] = useState('');
  const salva = async () => {
    if (!testo.trim()) return;
    try {
      await axios.post(`${API}/clienti/${clienteId}${aggiungi}`, { testo });
      setTesto(''); setScrivi(false);
      onFatto();
    } catch { toast.error('Nota non salvata'); }
  };
  return (
    <section className="card r" data-testid="note-interne">
      <div className="ttl"><div className="i"><Icona nome="documento" /></div><h2>Note interne</h2><button type="button" className="link" onClick={() => setScrivi(!scrivi)}>+ Nota</button></div>
      {scrivi && (
        <div className="campo-nota" style={{ marginBottom: '.6rem' }}>
          <textarea value={testo} onChange={(e) => setTesto(e.target.value)} rows={2} placeholder="Solo per lo staff" aria-label="Nuova nota" autoFocus />
          <button type="button" className="btn sm p" onClick={salva}>Salva</button>
        </div>
      )}
      {!note.length && !scrivi && <p className="vuoto">Nessuna nota.</p>}
      {note.slice(0, limite).map((n, i) => <div className="note" key={`${n.data}-${i}`}>{n.testo}{(n.autore || n.data) && <small>{[n.autore, n.data].filter(Boolean).join(' · ')}</small>}</div>)}
    </section>
  );
};

// La disponibilità del cliente per le visite, modificabile da admin e collaboratore che lo segue (la stessa del cliente)
export const DisponibilitaStaff = ({ clienteId, nome, onCambia }) => (
  <section className="card r disp-staff" data-testid="disponibilita-staff">
    <div className="ttl"><div className="i g"><Icona nome="orologio" /></div><h2>Disponibilità per le visite</h2></div>
    <Disponibilita clienteId={clienteId} dello_staff titolo="" onCambia={onCambia}
      spiegazione={`La stessa griglia che ${nome || 'il cliente'} vede nel suo calendario: chi la cambia per ultimo vince. Se la segnate voi, gli arriva un avviso per controllarla.`} />
  </section>
);
